import styled from 'styled-components';

interface ContainerProps {
  gridColumn?: number;
  border?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 10px 15px;
  border-radius: 6px;
  background-color: white;
  grid-column: ${({gridColumn}) => `span ${gridColumn ?? 12}`};
  ${(props) => props.border && 'border: 1px solid rgba(128, 128, 128, 0.6);'}
`;

export const Label = styled.label`
  font-weight: 600;
  color: rgba(0, 0, 0, 0.6);
`;

export const FileHolder = styled.div`
  display: flex;
  align-items: center;
  height: 45px;
  gap: 15px;
`;
